import React, { useState } from 'react';
import api from '../api/api';
import { useNavigate } from 'react-router-dom';

const DifficultyBadge = ({ level }) => {
  const levels = {
    1: { text: 'Facile', style: { backgroundColor: '#87A96B', color: '#ffffff' } },
    2: { text: 'Moyen', style: { backgroundColor: '#E67E22', color: '#ffffff' } },
    3: { text: 'Difficile', style: { backgroundColor: '#e74c3c', color: '#ffffff' } }
  };
  const fallback = { text: 'Niveau ?', style: { backgroundColor: '#6c757d', color: '#ffffff' } };
  const badge = levels[level] || fallback;

  return (
    <span className="text-xs px-2 py-1 rounded-full font-medium" style={badge.style}>
      {badge.text}
    </span>
  );
};

const SuggestionsList = ({ suggestions, onSelectRecipe, parameters, userId }) => {
  const [loadingRecipes, setLoadingRecipes] = useState({});
  const navigate = useNavigate();

  const handleCreateRecipe = async (recipe, dishType, e) => {
    e.stopPropagation();
    setLoadingRecipes(prev => ({ ...prev, [recipe.title]: true }));
    
    try {
      if (recipe.already_generated_recipe_id) {
        navigate(`/recette/${recipe.already_generated_recipe_id}?lastPageType=suggestions`);
        return;
      }
      else {
        console.log(recipe)
        const response = await api.post('/api/meals/transform-suggestion-to-recipe', {
          title: recipe.title,
          imgUrlArray: recipe.imgUrlArray,
          englishTitle: recipe.englishTitle,
          visualDescription: recipe.visualDescription,
          parameters: parameters,
          userId: userId,
          description: recipe.description,
          dishType: dishType,
        });
        
        if (response.data.success) {
          const updateSuggestionInGroup = (categoryGroup) => {
            if (categoryGroup.type !== dishType) {
              return categoryGroup;
            }

            const updateSuggestionInArray = (suggestionsArray) => {
              return suggestionsArray.map(suggestion => {
                if (suggestion.title === recipe.title) {
                  return {
                    ...suggestion,
                    already_generated_recipe_id: response.data.recipe.id
                  };
                }
                return suggestion;
              });
            };

            if (categoryGroup.suggestions?.suggestions) {
              return {
                ...categoryGroup,
                suggestions: {
                  ...categoryGroup.suggestions,
                  suggestions: updateSuggestionInArray(categoryGroup.suggestions.suggestions)
                }
              };
            } else if (Array.isArray(categoryGroup.suggestions)) {
              return {
                ...categoryGroup,
                suggestions: updateSuggestionInArray(categoryGroup.suggestions)
              };
            } else {
              console.warn('Structure de suggestions inattendue:', categoryGroup);
              return categoryGroup;
            }
          };

          const updatedSuggestions = suggestions.map(updateSuggestionInGroup);

          console.log("Updated suggestions:", updatedSuggestions);
          
          localStorage.setItem('lastSuggestions', JSON.stringify(updatedSuggestions));
          localStorage.setItem('lastParameters', JSON.stringify(parameters));
          
          navigate(`/recette/${response.data.recipe.id}?lastPageType=suggestions`);
        } else {
          throw new Error(response.data.message);
        }
      }

    } catch (error) {
      console.error("Erreur lors de la génération de la recette:", error);
      if (!(error?.response && error.response.status === 429)) {
        alert("Erreur lors de la création de la recette");
      }
    } finally {
      setLoadingRecipes(prev => ({ ...prev, [recipe.title]: false }));
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6" style={{ color: '#2C3E50' }}>Suggestions de Recettes de YAQAM</h1>
      
      {suggestions.map((categoryGroup, index) => (
        <div key={index} className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 flex items-center" style={{ color: '#2C3E50' }}>
            <span className="mr-2">{categoryGroup.type}</span>
          </h2>
          
          <div className="space-y-4">
            {categoryGroup.suggestions.map((recipe, recipeIndex) => (
              <div
                key={recipeIndex}
                className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all flex flex-col sm:flex-row items-stretch sm:items-center p-4 border border-gray-100 w-full"
              >
                {/* Image carrée à gauche */}
                <div className="w-full h-48 sm:w-40 sm:h-40 flex-shrink-0 overflow-hidden rounded-2xl bg-gray-100 flex items-center justify-center sm:mr-4 mb-3 sm:mb-0 relative group">
                  {recipe.imgUrlArray && recipe.imgUrlArray.length > 0 ? (
                  <>
                    <img
                    src={recipe.imgUrlArray[0]}
                    alt={recipe.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110 cursor-zoom-in"
                    onClick={(e) => {
                      e.stopPropagation();
                      const overlay = document.createElement('div');
                      overlay.className = 'fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 cursor-zoom-out';
                      overlay.onclick = () => overlay.remove();
                      
                      const img = document.createElement('img');
                      img.src = recipe.imgUrlArray[0];
                      img.className = 'max-w-[90vw] max-h-[90vh] object-contain';
                      
                      overlay.appendChild(img);
                      document.body.appendChild(overlay);
                    }}
                    />
                    <div className="absolute top-2 right-2 bg-black bg-opacity-50 rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                    </svg>
                    </div>
                  </>
                  ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <svg className="animate-spin h-10 w-10" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" style={{ color: '#6c757d' }}>
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  </div>
                  )}
                </div>
                        
                {/* Contenu à droite */}
                <div className="flex-grow min-w-0">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-lg font-medium flex-grow leading-tight pr-2" style={{ color: '#2C3E50' }}>
                      {recipe.title}
                    </h3>
                    <DifficultyBadge level={recipe.level} />
                  </div>
                  <p className="text-sm mb-3 line-clamp-2" style={{ color: '#6c757d' }}>
                    {recipe.description}
                  </p>
                </div>
                
                {/* Bouton à droite */}
                <div className="flex-shrink-0 sm:ml-4 mt-2 sm:mt-0 self-end sm:self-auto">
                  <button
                    onClick={(e) => handleCreateRecipe(recipe, categoryGroup.type, e)}
                    disabled={loadingRecipes[recipe.title]}
                    className={`px-6 py-2 rounded-full text-white font-medium text-sm transition-all ${
                      loadingRecipes[recipe.title]
                        ? 'cursor-wait opacity-70'
                        : 'hover:opacity-90'
                    }`}
                    style={{ backgroundColor: '#87A96B' }}
                  >
                    {loadingRecipes[recipe.title] ? (
                      <div className="flex items-center justify-center">
                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 714 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Création...
                      </div>
                    ) : (
                      'CRÉER'
                    )}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SuggestionsList;
